// extracted by css-extract-rspack-plugin
export default {"cls1":"DebugPage-cls1_jnR","cls2":"DebugPage-cls2_BcL DebugPage-cls1_jnR","near-limit":"DebugPage-near-limit_mN7"};